/**
 * Messages browsers raise when a lazy `import()` requests a chunk the deploy has already
 * replaced — the tab is running the previous build. Vite's CSS variant is included because
 * `manualChunks` emits per-route CSS. Deliberately NOT added to RUM `ignoreErrors`: the
 * reload below has no loop guard, and these events are the only evidence when it loops.
 * See PLAT-4152.
 */
export const staleChunkErrorPatterns = [
  // Chromium
  /Failed to fetch dynamically imported module/i,
  // Firefox
  /error loading dynamically imported module/i,
  // Safari
  /Importing a module script failed/i,
  // Vite, for a route's CSS
  /Unable to preload CSS for/i,
];

/**
 * True when an error message reports a failed dynamic import.
 * @param message - Error message to test.
 */
export const isStaleChunkError = (message: string): boolean =>
  staleChunkErrorPatterns.some((pattern) => pattern.test(message));
